import { DialogContent, List, ListItem, ListItemText } from '@mui/material';
import { type FC, useCallback } from 'react';

import { useDeleteNvr, useOneNvr } from '../../api/nvrs.api.js';
import DeleteDialog from '../DeleteDialog.js';

interface NvrDeleteProps {
  open: boolean;
  onClose: () => void;
  nvrId?: string;
  refetch: () => void;
}

const NvrDelete: FC<NvrDeleteProps> = ({ open, onClose, nvrId, refetch }) => {
  const { data } = useOneNvr(nvrId!, { enabled: !!nvrId });
  const deleteMutation = useDeleteNvr();

  const onSubmit = useCallback(async () => {
    if (data?.id) {
      return deleteMutation.mutateAsync(data.id);
    }
  }, [data, deleteMutation]);

  return (
    <DeleteDialog open={open} name={'NVR'} onClose={onClose} onSubmit={onSubmit} refetch={refetch}>
      {data ? (
        <DialogContent>
          <List dense>
            <ListItem>
              <ListItemText primary={`Name: ${data.name}`} />
            </ListItem>
            <ListItem>
              <ListItemText primary={`IP Address: ${data.ipAddress}`} />
            </ListItem>
            <ListItem>
              <ListItemText primary={`Port: ${data.port}`} />
            </ListItem>
          </List>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default NvrDelete;
